<template>
  <expansion-panel
    name="employer"
    ref="ztExpansionPanelEmployer"
    :title="$t('message.abm.folders.signatureTool.singEmployer')"
    class="mb-4"
    prepend-icon="sign-pencil-outline"
    :disabled="disabled"
    @handleClick="setFocusPanel"
  >
    <div class="mb-4">
      <p class="text-zt-dark-300 flex items-center justify-self-start mb-4">
        <zt-check-box fill v-model="shown" @change="shownSignatureEmployer" data-vs-check-box="shownSignatureEmployer">
          {{ $t('message.abm.folders.toolbox.signShow') }}
        </zt-check-box>
      </p>
      <p class="text-zt-dark-300 mb-4 font-125">
        {{ $t('message.abm.folders.toolbox.singDescription') }}
      </p>
      <div v-if="shown">
        <zt-button
          class="setting-button mb-4"
          outlined
          @click="setPositionPage('first')"
          data-vs-button="setPositionPage"
        >
          <span>{{ $t('message.abm.folders.toolbox.firstPage') }}</span>
          <zt-icon v-if="pageSelected === 'first'" name="check" />
        </zt-button>
        <zt-button
          class="setting-button mb-4"
          outlined
          @click="setPositionPage('last')"
          data-vs-button="setPositionPage"
        >
          <span>{{ $t('message.abm.folders.toolbox.lastPage') }}</span>
          <zt-icon v-if="pageSelected === 'last'" name="check" />
        </zt-button>
        <div class="rotate-button relative flex items-center rounded justify-between w-full border border-zt-primary-200 p-3 mb-4">
          <span>{{ $t('message.abm.folders.toolbox.customPage') }}</span>
          <div class="input-number-wrapper absolute right-0 mr-3">
            <input
              type="text"
              class="p-1 rounded border w-full"
              :maxlength="maxLength"
              v-model="paginationInput"
              @input="setCustomPage"
              data-vs-input="setCustomPage"
            />
          </div>
          <zt-icon v-if="pageSelected === 'custom'" name="check" />
        </div>
        <p
          v-if="isModified || shown"
          class="text-zt-dark-400 mt-2 underline cursor-pointer inline-block"
          @click="clear"
          data-vs-button="clear"
        >
          {{ $t('message.abm.folders.toolbox.undo') }}
        </p>
        <div
          v-show="showDeleteBox"
          ref="warningDeleteBox"
          class="absolute bg-white rounded position-box box-deleted p-4 flex flex-column"
          :style="cordsDeleteBox"
        >
          <p class="font-medium mb-3">{{ $t('message.abm.folders.toolbox.undoTitle') }}</p>
          <p class="text-zt-dark-300 text-zt-base">{{ $t('message.abm.folders.toolbox.singEmpQuestion') }}</p>
          <div class="flex justify-end h-full items-end">
            <zt-button text style="color: #4a4a4a !important;" class="text-zt-base" @click="closeBoxDelete" data-vs-button="closeBoxDelete">
              {{ $t('message.abm.folders.toolbox.cancel') }}
            </zt-button>
            <zt-button class="text-zt-base ml-2" @click="clearSignature" data-vs-button="clearSignature">
              {{ $t('message.abm.folders.toolbox.confirmUndo') }}
            </zt-button>
          </div>
        </div>
      </div>
    </div>
  </expansion-panel>
</template>
<script>
import ExpansionPanel from '../generic/ExpansionPanel'
import { convertLastPage } from '../../../../utils'
import { isEqual, isEmpty } from 'lodash'
export default {
  name: 'EmployerSignatureActionPanel',
  inject: [
    'modalState',
    'setFocusPanel',
    'setModalStateProperty',
    'signatureState',
    'signatureToolApplied',
    'updateVisorPDF'
  ],
  components: {
    ExpansionPanel
  },
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    document: {
      type: Object,
      default: () => ({})
    },
    preset: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      shown: this.preset.show || false,
      pagination: 1,
      paginationInput: '',
      pageSelected: 'first',
      maxLength: 1,
      showDeleteBox: false,
      cordsDeleteBox: {},
      cache: {}
    }
  },
  computed: {
    isModified() {
      return !isEqual(this.cache, this.preset)
    }
  },
  watch: {
    pagination() {
      const page = parseInt(this.pagination)
      this.setModalStateProperty({ page }, 'employer', 'preset')
      this.updateVisorPDF({ page })
    },
    shown() {
      if (this.shown && !isEmpty(this.document)) {
        const { document: { _pdfInfo } } = this.document
        this.maxLength = (_pdfInfo.numPages).toString().length
        this.defaultPage(_pdfInfo)
      }
    },
    showDeleteBox() {
      if (this.showDeleteBox) {
        this.insertContent(this.$refs.warningDeleteBox)
      }
    }
  },
  created() {
    this.cache = this.preset
  },
  methods: {
    clear(e) {
      this.showDeleteBox = true
      this.$nextTick(() => {
        this.cordsDeleteBox = this.positionBox(e.target)
      })
    },
    clearSignature() {
      this.$emit('clear', 'employer')
      this.closeBoxDelete()
    },
    close() {
      this.$refs.ztExpansionPanelEmployer.close()
    },
    closeBoxDelete() {
      this.showDeleteBox = false
      this.deleteContent()
    },
    defaultPage(_pdfInfo) {
      if (!this.preset) {
        this.paginationInput = 1
        this.pageSelected = 'first'
        this.pagination = 1
        return
      }
      if (this.preset.page === 1) this.pageSelected = 'first'
      if (this.preset.page === -1) this.pageSelected = 'last'
      if (this.preset.page > 1 && this.preset.page !== _pdfInfo.numPages) {
        this.paginationInput = this.preset.page
        this.pageSelected = 'custom'
      }
    },
    deleteContent() {
      let [parent] = document.getElementsByTagName('body')
      if (
          parent &&
          this.$refs.warningDeleteBox &&
          this.$refs.warningDeleteBox.parentNode === parent
      ) {
        parent.removeChild(this.$refs.warningDeleteBox)
      }
    },
    insertContent(elz) {
      let content = document.body
      content.insertBefore(elz, content.firstChild)
    },
    positionBox(el) {
      let chipWrapper = el
      let scrollContentTop = window.pageYOffset || document.documentElement.scrollTop
      let topPos = chipWrapper.getBoundingClientRect().top + scrollContentTop - chipWrapper.clientHeight
      let leftPost = chipWrapper.getBoundingClientRect().right + 12
      return {
        left: `${leftPost}px`,
        top: `${topPos}px`
      }
    },
    setCustomPage(event) {
      const numberPage = parseInt(event.target.value)
      const { document: { _pdfInfo } } = this.document
      if (this.paginationInput === '') return
      this.pagination = numberPage
      if (numberPage < 1 ) {
        this.pagination = 1
        this.paginationInput = 1
      }
      if (numberPage > _pdfInfo.numPages) {
        this.pagination = _pdfInfo.numPages
        this.paginationInput = _pdfInfo.numPages
      }
      this.pageSelected = 'custom'
      this.updateVisorPDF({ page: this.pagination })
    },
    async setPositionPage(page) {
      const { document: { _pdfInfo } } = this.document
      this.pagination = page === 'first' ? 1 : -1
      this.pageSelected = page
      this.paginationInput = ''
      await this.setModalStateProperty({ page: this.pagination }, 'employer', 'preset')
      await this.updateVisorPDF({ page: this.pagination })
    },
    shownSignatureEmployer(show) {
      const newPosition = this.signatureState('employer', show)
      const employer = {
        isVisible: newPosition.show,
        orientation: this.modalState.config.orientation,
        paper: this.modalState.config.paper,
        preset: newPosition
      }
      this.setModalStateProperty(employer, 'employer')
      this.signatureToolApplied(show, 'signEmp')
      this.updateVisorPDF({ page: newPosition.page })
    }
  },
  beforeDestroy() {
    this.deleteContent()
  }
}
</script>
<style scoped lang="scss">
.input-number-wrapper {
  width: 33px;
  input {
    border-color: #4F41A3!important;
  }
}
::v-deep {
  .setting-button {
    width: 100% !important;
    justify-content: flex-start !important;
    font-size: 1.125rem !important;
    height: 50px !important;
    .zt-button-text {
      margin: 0 !important;
    }
    .zt-icon {
      position: absolute;
      right: 15px;
      top: 18px;
    }
  }
}
.position-box {
  width: 350px;
  height: 176px;
  z-index: 9999;
  box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
  -webkit-box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
  -moz-box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
}
.box-deleted:after {
  content: "";
  background: inherit;
  width: 16px;
  height: 16px;
  position: absolute;
  display: block;
  left: -14px;
  transform: rotate(45deg) translateY(-50%);
  top: 25%;
  border-left: 1px solid #D0D0D0FF;
  border-bottom: 1px solid #D0D0D0FF;
}
</style>
